import { render, staticRenderFns } from "./MdCensusByProgram.vue?vue&type=template&id=1d88a3d5&scoped=true&"
import script from "./MdCensusByProgram.vue?vue&type=script&lang=js&"
export * from "./MdCensusByProgram.vue?vue&type=script&lang=js&"
import style0 from "./MdCensusByProgram.vue?vue&type=style&index=0&id=1d88a3d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d88a3d5",
  null
  
)

export default component.exports